import { useContext } from "react";
import { NavigationBlockerActions, NavigationBlockerContextDispatch } from "./NavigationBlockerContext";

export function useNavigationBlockerActions(): NavigationBlockerActions {
    return useContext(NavigationBlockerContextDispatch)!;
};

export default useNavigationBlockerActions;
